import { KpiCardValue, KpiValue } from '@app/components/kpi';
import { AuditReportsBroadcastEvidenceConfigDto } from '@mi-front/api-v2';
import { Box } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  scheduled: {
    id: 'audit.broadcastEvidence.summary.scheduled',
    defaultMessage: 'Pautados',
  },
  olafMatched: {
    id: 'audit.broadcastEvidence.summary.olafMatched',
    defaultMessage: 'OLAF',
  },
  alternativeConfirmed: {
    id: 'audit.broadcastEvidence.summary.alternativeConfirmed',
    defaultMessage: 'Confirmados',
  },
  withinTolerance: {
    id: 'audit.broadcastEvidence.summary.withinTolerance',
    defaultMessage: 'En tolerancia',
  },
  outsideTolerance: {
    id: 'audit.broadcastEvidence.summary.outsideTolerance',
    defaultMessage: 'Fuera de tolerancia',
  },
});

interface Props {
  summary: AuditReportsBroadcastEvidenceConfigDto['summary'];
}

const kpiRowGridSx = {
  display: 'grid',
  gap: 2,
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(5, minmax(0, 1fr))',
  },
} as const;

/**
 * KPI strip for broadcast evidence summary counters (scheduled, OLAF, confirmed, tolerance).
 */
export function BroadcastEvidenceSummaryKpis({ summary }: Props) {
  const { $t, locale } = useIntl();

  const cards = [
    { title: $t(messages.scheduled), value: summary.scheduled },
    { title: $t(messages.alternativeConfirmed), value: summary.alternativeConfirmed },
    { title: $t(messages.withinTolerance), value: summary.withinTolerance },
    { title: $t(messages.outsideTolerance), value: summary.outsideTolerance },
    { title: $t(messages.olafMatched), value: summary.olafMatched },
  ];

  return (
    <Box sx={{ ...kpiRowGridSx, mt: 2 }}>
      {cards.map((card) => (
        <KpiCardValue
          key={card.title}
          size="sm"
          title={card.title}
          value={<KpiValue type="number" locale={locale} value={card.value} />}
        />
      ))}
    </Box>
  );
}
